import Vue from 'vue';
import '../utils/icons';
import ACTION from '../store/ACTION';
import { ChannelVisibility } from '@lumiere/db/types';
import Loading from '@/components/ViewerLoading.vue';
import { mapGetters } from 'vuex';
import { ViewerRoutes } from '../router';
import ChannelNavbar from '@/components/ChannelNavbar.vue';
import ChannelBanner from '@/components/ChannelBanner.vue';
import ChannelSidepanel from '@/components/ChannelSidepanel.vue';
import omit from 'lodash/omit';
import { LUMIERE_EMBED_EVENTS } from '../utils/types';
// import PageTransition from '@/components/PageTransition.vue'
import { EmbedActionTypes } from '@lumiere/shared/types';
export default Vue.extend({
    props: {
        cid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            filters: {},
            showSidepanel: false,
        };
    },
    methods: {
        async fetchChannel() {
            return this.$store.dispatch(ACTION.FETCH_CHANNEL, this.cid);
        },
        getWindowDimension() {
            const channelContainer = this.$refs.viewerChannel;
            if (channelContainer) {
                const { width, height } = channelContainer.getBoundingClientRect();
                void this.$store.dispatch(ACTION.NOTIFY_PARENT_WINDOW, {
                    event: LUMIERE_EMBED_EVENTS.CHANNEL_WINDOW_DIMENSION,
                    dimension: { width, height },
                    embedActionType: EmbedActionTypes.CHANNEL_VIEWER_FEEDBACK,
                });
            }
        },
        removeTag() {
            this.filters = omit(this.filters, 'tag');
        },
        scrollHandler() {
            let sidePanel = document.getElementById('channel-sidepanel-main');
            if (sidePanel) {
                if (window.pageYOffset + 30 > sidePanel.offsetTop) {
                    sidePanel.classList.add('viewer-channel__aside--floating');
                }
                else {
                    sidePanel.classList.remove('viewer-channel__aside--floating');
                }
            }
        },
    },
    computed: {
        ...mapGetters(['getUser', 'channelVideos']),
        channel() {
            return this.$store.state.channel?.channel;
        },
        customCSS() {
            return this.channel.options?.css;
        },
        routes() {
            return ViewerRoutes;
        },
        renderSidePanel() {
            const { showSearch, showTagNavigation } = this?.channel.options;
            return showSearch || showTagNavigation;
        },
        showSearch() {
            const { showSearch } = this?.channel.options;
            return showSearch;
        },
        showTagNavigation() {
            const { showTagNavigation } = this?.channel.options;
            return showTagNavigation;
        },
        isPrivateChannel() {
            return this.channel?.visibility === ChannelVisibility.Private;
        },
    },
    async serverPrefetch() {
        return this.fetchChannel();
    },
    mounted() {
        if (this.cid && !this.channel) {
            void this.fetchChannel();
        }
        void this.$store.dispatch(ACTION.CREATE_VIEW_RECORD, {
            cid: this.cid,
        });
        window.addEventListener('beforeunload', (_evt) => {
            void this.$store.dispatch(ACTION.VIEW_SESSION_ENDED);
        });
        window.addEventListener('resize', this.getWindowDimension);
        this.$nextTick(() => {
            void this.$store.dispatch(ACTION.NOTIFY_PARENT_WINDOW, {
                event: LUMIERE_EMBED_EVENTS.CHANNEL_EMBED_MOUNTED,
                embedActionType: EmbedActionTypes.CHANNEL_VIEWER_FEEDBACK,
            });
        });
        window.addEventListener('scroll', this.scrollHandler);
    },
    watch: {
        '$route.params.vid': {
            handler(vid, prevVid) {
                // const vid = params?.vid
                // const prevVid = oldParams?.vid
                if (prevVid) {
                    void this.$store.dispatch(ACTION.NOTIFY_PARENT_WINDOW, {
                        event: LUMIERE_EMBED_EVENTS.CHANNEL_VIDEO_UNLOADED,
                        vid: prevVid,
                    });
                }
                if (vid) {
                    void this.$store.dispatch(ACTION.NOTIFY_PARENT_WINDOW, {
                        event: LUMIERE_EMBED_EVENTS.CHANNEL_VIDEO_LOADED,
                        video: { id: vid },
                        vid,
                    });
                }
            },
            immediate: true,
            // deep: true,
        },
        'filters': {
            handler(filter) {
                const tag = filter?.tag;
                const search = filter?.search;
                if (tag) {
                    this.showSidepanel = false;
                    void this.$store.dispatch(ACTION.NOTIFY_PARENT_WINDOW, {
                        event: LUMIERE_EMBED_EVENTS.FILTER_BY_TAG,
                        tag: tag, // could be id or the entire tag object
                    });
                }
                else if (search) {
                    void this.$store.dispatch(ACTION.NOTIFY_PARENT_WINDOW, {
                        event: LUMIERE_EMBED_EVENTS.FILTER_BY_SEARCH,
                        query: search,
                    });
                }
            },
            immediate: true,
            deep: true,
        },
        'channel': {
            handler(channel) {
                if (channel) {
                    void this.$store.dispatch(ACTION.NOTIFY_PARENT_WINDOW, {
                        event: LUMIERE_EMBED_EVENTS.CHANNEL_EMBED_RENDERED,
                        embedActionType: EmbedActionTypes.CHANNEL_VIEWER_FEEDBACK,
                    });
                    this.$nextTick(this.getWindowDimension);
                }
            },
            immediate: true,
        },
    },
    components: {
        Loading,
        ChannelNavbar,
        // PageTransition,
        ChannelBanner,
        ChannelSidepanel,
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getWindowDimension);
    },
});
